import { connectFela } from '../../../dependencies';
import Empty from './Empty';
import * as styles from './Empty.styles';

export default connectFela(styles)(Empty);
